import { useIntl } from 'react-intl';

import { Carousel, useCarousel } from '../../../domains/Layout/Carousel/Carousel';
import { Destination } from '../../../resources/destination/domain/types/destination';
import { getFacetTagCategoryTrackingProperty } from '../../../resources/facet/domain/operations/getFacetTagCategoryTrackingProperty';
import { getFacetTagNameTrackingProperty } from '../../../resources/facet/domain/operations/getFacetTagNameTrackingProperty';
import { Facet } from '../../../resources/facet/domain/types/facet';
import { FacetCard } from '../../../shared/components/FacetCard/FacetCard';
import { PickDomain } from '../../../shared/utilities/types/PickDomain';

type Props = {
    suggestedFacets: PickDomain<
        Facet,
        'id' | 'squareImage' | 'coverImage' | 'slug' | 'title' | 'filter',
        {
            destination: Pick<Destination, 'slug'>;
        }
    >[];
    destination: PickDomain<Destination, 'slug' | 'id'>;
};

export function SuggestedFacets({ suggestedFacets, destination }: Props) {
    const { formatMessage } = useIntl();
    const suggestedFacetsCarousel = useCarousel();

    return (
        <>
            <div className="font-l-extrabold mb-24" role="heading" aria-level={2}>
                {formatMessage({ id: 'page.facet.suggestedFacets.title' })}
            </div>
            <Carousel
                {...suggestedFacetsCarousel}
                slidesVisibleRules={{
                    sm: 2,
                    md: 3,
                    lg: 3,
                    xl: 3,
                    xxl: 3,
                }}
            >
                {suggestedFacets.map((suggestedFacet, index) => {
                    return (
                        <FacetCard
                            key={suggestedFacet.id}
                            facet={{
                                ...suggestedFacet,
                                destination,
                            }}
                            image={{
                                sizes: '(min-width: 1200px) 400px, 300px',
                            }}
                            trackingInformation={{
                                click: {
                                    facet_id: suggestedFacet.id,
                                    destination_id: destination.id,
                                    destination_slug: destination.slug,
                                    card_number: index + 1,
                                    row_number: 0,
                                    block: 'facets',
                                    facet_tag_category:
                                        getFacetTagCategoryTrackingProperty(suggestedFacet),
                                    facet_tag_name: getFacetTagNameTrackingProperty(suggestedFacet),
                                },
                            }}
                            small
                        />
                    );
                })}
            </Carousel>
        </>
    );
}
